import { SIGNUP_PATH } from "constants/routes"
import { FC } from "react"
import { useHistory, useLocation } from "react-router"
import { useRedirectLoggedInUser } from "../hooks/useRedirectLoggedInUser"
import { LoginForm } from "./LoginForm"
import { PageMetadata } from "components/shared/PageMetadata"
import { FormWrapper } from "../FormWrapper"

const LoginPage: FC = () => {
    useRedirectLoggedInUser()
    const history = useHistory()
    const location = useLocation()

    return (
        <>
            <PageMetadata
                title="Recall Login"
                description="Login to your Recall account to explore connections in your summaries."
            />
            <FormWrapper>
                <LoginForm onClickSignup={() => history.push(SIGNUP_PATH + location.search)} />
            </FormWrapper>
        </>
    )
}

export default LoginPage
